import { render, staticRenderFns } from "./Dinding.vue?vue&type=template&id=10ed19b2&scoped=true"
import script from "./Dinding.vue?vue&type=script&lang=js"
export * from "./Dinding.vue?vue&type=script&lang=js"
import style0 from "./Dinding.vue?vue&type=style&index=0&id=10ed19b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed19b2",
  null
  
)

export default component.exports